import { memo, useMemo } from 'react';
import ConfirmationBody from '../../../PlaceOrderTypes/ConfirmationModal/ConfirmationBody';
import { Col, Container, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { API_RESPONSE_STATUS } from '../../../../utils/global_variables';

//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
const SideOrderConfirmation = ({ layoutType, GTDNoOfDays, defaultGtdDate, orderEntryTab, activeTabKey, scripOrderInfo, handleClose, selectOrderOption, orderInputs, activeButtonToggleIndex, marginInfoHandler, bIsConfirmBtn, setBIsConfirmBtn, arrMultiLegInfo, bIsCoverBracketOrderOpen }) => {

    const bIsShowSideTrayOrderConfirmation = useSelector(state => state?.orders?.bIsShowSideTrayOrderConfirmation);
    const objMultiLegOrderResp = useSelector(state => state.orders.placeMultilegOrder);

    const nOrderValue = useMemo(() => {
        return orderInputs.scripQuantity * orderInputs.scripPrice;
    }, [orderInputs]);

    return (
        bIsShowSideTrayOrderConfirmation &&
        <>
            <Container fluid className='p-0'>
                <Row className='g-0 p-3 order-confirmation-singlescrip-height'>
                    <Col md={12}>
                        <ConfirmationBody layoutType={layoutType} GTDNoOfDays={GTDNoOfDays} defaultGtdDate={defaultGtdDate} orderEntryTab={orderEntryTab} activeTabKey={activeTabKey} activeButtonToggleIndex={activeButtonToggleIndex} scripOrderInfo={scripOrderInfo} selectOrderOption={selectOrderOption} nOrderValue={nOrderValue} orderInputs={orderInputs} marginInfoHandler={marginInfoHandler} bIsConfirmBtn={bIsConfirmBtn} setBIsConfirmBtn={setBIsConfirmBtn} arrMultiLegInfo={arrMultiLegInfo} bIsCoverBracketOrderOpen={bIsCoverBracketOrderOpen} />
                    </Col>
                    {/** To shown any api error msg right on order confirmation screen in sidetray to give visual indicator */}
                    {
                        objMultiLegOrderResp?.response?.data?.status === API_RESPONSE_STATUS.ERROR ?
                            <Col md={12}>
                                <div className='error-msg text-wrap'>{objMultiLegOrderResp?.response.data.message}</div>
                            </Col> : null
                    }
                </Row>
            </Container> {/* BT-106965 : Order Cart : ManasaB : 23-07-2024 : Side tray code changes   */}
        </>
    );
};
//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End
export default memo(SideOrderConfirmation);
